/* PDP Upsell Cards */
(function () {
  'use strict';

  if (window.customElements.get('kl-upsell-pdp')) return;

  class KlUpsellPdp extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-upsell-toggle]');
        if (!toggle) return;
        event.preventDefault();
        const selected = toggle.getAttribute('aria-pressed') !== 'true';
        toggle.setAttribute('aria-pressed', selected);
        toggle.closest('[data-upsell-card]').classList.toggle('is-selected', selected);
        this.syncInputs();
      }, { signal });

      document.addEventListener('cart:change', (event) => this.refresh(event.detail?.cart), { signal });

      const items = JSON.parse(this.querySelector('[data-cart-items]')?.textContent || '[]');

      this.refresh({ items }).finally(() => this.classList.add('is-ready'));
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.clearInputs();
    }

    get form() {
      return document.getElementById(this.getAttribute('form'));
    }

    get cards() {
      return Array.from(this.querySelectorAll('[data-upsell-card]'));
    }

    isSelected(card) {
      return card.querySelector('[data-upsell-toggle]').getAttribute('aria-pressed') === 'true';
    }

    async refresh(cart) {
      if (!cart || !Array.isArray(cart.items)) return;

      const cartIds = cart.items.map((item) => String(item.id));
      const cartHandles = cart.items.map((item) => item.handle);
      let reappeared = false;

      this.cards.forEach((card) => {
        const inCart = cartIds.includes(card.dataset.variantId) || cartHandles.includes(card.dataset.productHandle);

        if (inCart) {
          if (card.hidden || card.classList.contains('is-fading')) return;
          this.fadeOut(card);
        } else if (card.hidden || card.classList.contains('is-fading')) {
          reappeared = true;
          card.hidden = false;
          card.classList.remove('is-fading');
        }
      });

      this.syncInputs();
      this.updateVisibility();

      if (reappeared) {
        this.querySelector('[data-upsell-track]')?.scrollTo({ left: 0, behavior: 'smooth' });
      }
    }

    fadeOut(card) {
      const toggle = card.querySelector('[data-upsell-toggle]');
      toggle.setAttribute('aria-pressed', 'false');
      card.classList.remove('is-selected');
      card.classList.add('is-fading');

      const onFadeEnd = (event) => {
        if (event.target !== card || event.propertyName !== 'opacity') return;
        card.removeEventListener('transitionend', onFadeEnd);
        if (!card.classList.contains('is-fading')) return;
        card.hidden = true;
        this.updateVisibility();
      };
      card.addEventListener('transitionend', onFadeEnd, { signal: this.abortController.signal });
    }

    updateVisibility() {
      const allHidden = this.cards.every((card) => card.hidden);
      this.classList.toggle('kl-upsell-pdp--hidden', this.cards.length === 0 || allHidden);
    }

    clearInputs() {
      if (!this.form) return;
      this.form.querySelectorAll('[data-upsell-input]').forEach((input) => input.remove());
    }

    syncInputs() {
      if (!this.form) return;
      this.clearInputs();

      const selected = this.cards.filter((card) => this.isSelected(card) && !card.hidden);

      selected.forEach((card, index) => {
        [['id', card.dataset.variantId], ['quantity', '1']].forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'items[' + (index + 1) + '][' + key + ']';
          input.value = value;
          input.dataset.upsellInput = '';
          this.form.appendChild(input);
        });
      });
    }
  }

  window.customElements.define('kl-upsell-pdp', KlUpsellPdp);
})();
